jQuery(document).ready(function () {
    jQuery(document).on('submit', 'form[name="optin-form"]', function () {
        jQuery('button.opt-in-submit').html('<i class="fas fa-spinner fa-spin"></i> &nbsp;Please Wait...').attr('disabled', true); // Change button text with spinner animation
    });
});